import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '@app/core/services';
import { MessageCenterAuthService } from '@app/modules/message-center/services';
import { MC_HOST } from '@app/modules/message-center/shared/MESSAGE_CENTER_URLS';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,
              private router: Router,
              private messageCenterAuthService: MessageCenterAuthService,) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestWithToken = this.setTokenIntoHeaders(request);

    return next.handle(requestWithToken).pipe(catchError((err) => {
      const isRequestToMessageCenter = this.isRequestToMessageCenter(request);
      if (err.status === 401 && !isRequestToMessageCenter) {
        this.logout();
      }
      return throwError(err);
    }));
  }

  private setTokenIntoHeaders(request: HttpRequest<any>): HttpRequest<any> {
    const isRequestToMessageCenter = this.isRequestToMessageCenter(request);
    const token = isRequestToMessageCenter ? this.messageCenterAuthService.getToken() : this.authService.getToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `${ isRequestToMessageCenter ? 'JWT' : 'Token' } ${ token }`
        }
      });
    }

    return request;
  }

  private isRequestToMessageCenter(request: HttpRequest<any>): boolean {
    return request.url.startsWith(MC_HOST);
  }

  private logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
